export const calculateScore = (
  wins: number,
  losses: number,
  escapes: number,
) => {
  return wins * 3 + losses * 1 - escapes * 2;
};
